import { FC, HTMLAttributes, ReactNode } from "react";
import styled from "styled-components";

type Props = HTMLAttributes<HTMLDivElement> & {
  label: ReactNode;
  color: string;
};
const SubHeadline: FC<Props> = ({ label, color, ...props }) => {
  return (
    <Root {...props}>
      <Bg $color={color} />
      <Label>{label}</Label>
    </Root>
  );
};
export default SubHeadline;

const Root = styled.div`
  position: relative;
`;

const Bg = styled.div<{ $color: string }>`
  position: absolute;
  top: 0;
  z-index: 0;
  height: 100%;
  width: 100%;
  background-color: ${({ $color }) => $color || "inherit"};
  transform: skewX(-30deg);
`;

const Label = styled.div`
  position: relative;
  z-index: 1;
  padding: 0.3em 0;
  font-size: 1.2em;
  color: white;
  font-family: sans-serif;
  font-weight: bold;
  text-align: center;
`;
